import { render, staticRenderFns } from "./BoletimOcorrenciaForm.vue?vue&type=template&id=1cdf4b8b"
import script from "./BoletimOcorrenciaForm.vue?vue&type=script&lang=js"
export * from "./BoletimOcorrenciaForm.vue?vue&type=script&lang=js"
import style0 from "./BoletimOcorrenciaForm.vue?vue&type=style&index=0&id=1cdf4b8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports